<script setup>
let props = defineProps(['data', 'size'])
</script>

<template>
    <div>
        <template v-if="$root.isUI('FUND')">
            <span :style="{backgroundImage: `url(${model.urls.assets.fundGeneral.loader})`}" class="preload-spinner"></span>
        </template>
        <template v-else>
            <span :style="{height: props.size + 'px', fontSize: props.size + 'px'}" class="preload-spinner"></span>
        </template>
    </div>
</template>